import script from "./ProjectManageUploadSettingSubtitleSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageUploadSettingSubtitleSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageUploadSettingSubtitleSection.vue?vue&type=style&index=0&id=7c3364d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3364d2"]])

export default __exports__